<template>
    <v-select v-model="area" :options="areaOptions" label="name" class="w-full"/>
</template>

<script>
export default {
  name: 'ht-staff-area-select',
  data() {
    return {
      areaOptions: [
        {lat: 51.8427533, lng: 4.3353594, name: 'Spijkenisse', zoom: 13, orders: []},
        {lat: 51.9239947, lng: 4.3609799, name: 'Schiedam', zoom: 12.8, orders: []},
        // {lat: 51.8247412, lng: 4.2563312, name: 'Zuidland', zoom: 14, orders: []},
        {lat: 51.8798463, lng: 4.5690483, name: 'Ijsselmonde', zoom: 12, orders: []},
        {lat: 52.019975, lng: 4.340991, name: 'Delft', zoom: 12, orders: []}
      ],
      area: null
    };
  },
  created() {
    this.area = this.areaOptions[0];
  },
  watch: {
    area: function () {
      this.$events.fire('staff-area-selected', this.area);
      localStorage.setItem('staff-area-selected', JSON.stringify(this.area));
    }
  }
};
</script>
